import * as React from 'react';

import { FormParserContext } from 'src/contexts/form.context';
import { InputContext } from 'src/contexts/input.context';
import { PlacesAutoComplete } from 'src/components/InputRenderers';
import { ifTrue } from 'src/tools/logic.tools';

export function PlacesInput() {
  const { value, script, onChange, error } = React.useContext(FormParserContext);

  return (
    <InputContext.Provider
      value={{
        classNames: { container: 'w-100p', input: ifTrue(error, 'with-error') },
        value,
        onChange,
        isDisabled: script.isDisabled,
        isAutoFocus: script.autofocus,
        placeholder: script.placeholder,
      }}
    >
      <PlacesAutoComplete />
    </InputContext.Provider>
  );
}
